import React, { memo, useRef } from 'react';

import classNames from 'classnames';

import cls from './DnD.module.css';
import { useDnD } from './useDnD';
import { FileInput } from '../FileInput/FileInput';

interface DnDProps {
    classes?: string;
    button?: string | null;
    children?: React.ReactNode;
    addImageTitle: string;
    onImageChange?: (files: File[]) => void;
    isClickDnd?: boolean;
    isDisabled?: boolean;
    isNotDnD?: boolean;
    dragClasses?: string;
}

export const DnD = memo(
    ({
        classes,
        button = null,
        children,
        addImageTitle,
        onImageChange,
        isClickDnd = true,
        isDisabled = false,
        isNotDnD = false,
        dragClasses,
    }: DnDProps) => {
        const {
            handleDrop,
            handleDragOver,
            isImageOver,
            handleDragLeave,
            handleDragEnter,
            handleInputChange,
        } = useDnD(onImageChange, isNotDnD);

        const fileInputRef = useRef<HTMLInputElement | null>(null);

        const handleDivClick = () => {
            if (isDisabled) return;
            fileInputRef.current?.click();
        };

        return (
            <div
                onDragEnter={handleDragEnter}
                className={classNames(cls.DnD, [classes])}
                onClick={!button && !isClickDnd ? undefined : handleDivClick}
            >
                {button && (
                    <FileInput
                        classes={cls.button}
                        buttonText={button}
                        onChange={handleInputChange}
                        accept=".jpg, .jpeg, .png, .gif"
                    />
                )}
                {children}
                {!!isImageOver && (
                    <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        className={classNames(classNames(cls.ActiveUploadArea, dragClasses))}
                    >
                        <div className={cls.addImageTitleWrapper}>
                            <div className={cls.addImageTitle}>{addImageTitle}</div>
                        </div>
                    </div>
                )}
                {!button && (
                    <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: 'none' }}
                        multiple
                        onChange={handleInputChange}
                    />
                )}
            </div>
        );
    }
);
